/* 🤖 this file was generated by svg-to-ts */
export const iconCalendarSmall: {
  name: 'calendar_small';
  data: string;
} = {
  name: 'calendar_small',
  data: `<!--calendar--><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 14H3c-.551 0-1-.448-1-1V8h12v5c0 .552-.449 1-1 1M3 4h10c.551 0 1 .448 1 1v1H2V5c0-.552.449-1 1-1m10-2V1a1 1 0 10-2 0v1H5V1a1 1 0 10-2 0v1C1.346 2 0 3.346 0 5v8c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3"/></svg>`,
};
